var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SearchableDocumentsList", {
    attrs: {
      companyId: _vm.companyId,
      currentUser: _vm.currentUser,
      searchByDocumentName: _vm.searchByDocumentName,
      query: _vm.query,
    },
    scopedSlots: _vm._u([
      {
        key: "filtersFullBlock",
        fn: function () {
          return [
            _c("SearchOnAction", {
              attrs: { nameSearchStyle: "pl-8" },
              on: { search: (value) => (_vm.searchByDocumentName = value) },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "emptyListActions",
        fn: function ({ refetchDocuments }) {
          return [
            _c("UploadDocument", {
              staticClass: "flex justify-end pt-3 pb-5",
              attrs: {
                companyId: _vm.companyId,
                currentUserId: _vm.currentUser.id,
              },
              on: { documentAdded: refetchDocuments },
            }),
          ]
        },
      },
      {
        key: "actions",
        fn: function ({ refetchDocuments }) {
          return [
            _c("UploadDocument", {
              staticClass: "flex justify-end",
              attrs: {
                companyId: _vm.companyId,
                currentUserId: _vm.currentUser.id,
                currentUser: _vm.currentUser,
              },
              on: { documentAdded: refetchDocuments },
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }